/**
 * @function requestIndexedDBValues
 * @param {string} dbName
 * @param {string} storeName
 * @param {string} key
 * @param {Function} success
 * @param {boolean} deletAfter
 */
export default function requestIndexedDBValues(dbName, storeName, key, success, deleteAfter = true) {
  const db = window.indexedDB.open(dbName);

  db.onsuccess = () => {
    try {
      // Get the objectStore values only if it exists
      if (db.result.objectStoreNames.contains(storeName)) {
        const tx = db.result.transaction(storeName, 'readwrite');
        const objStore = tx.objectStore(storeName);
        const valueRequest = objStore.get(key);

        valueRequest.onsuccess = () => {
          success(valueRequest);

          if (deleteAfter && objStore.delete) {
            objStore.delete(key);
          }
        };
      } else {
        // The store doesn't exist send gcc values only
        success({});
      }
    } catch (error) {
      // eslint-disable-next-line
      console.error(error);
    }

    db.result.close();
  };
}